import { useQuery } from '@tanstack/react-query';
import { fetchSubscriptionInvoices } from '../../services/subscriptions';
import useGetSubscription from './useGetSubscription';
import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';

function useGetSubscriptionInvoices() {
  const { user } = useUser<LoadedUser>();
  const { data: { subscription } = {} } = useGetSubscription();

  const businessId = user?.business?.id;
  const enabled = !!subscription?.id && !!businessId;

  const query = useQuery({
    queryKey: ['subscription-invoices', subscription?.id, businessId],
    queryFn: async () => {
      if (!subscription?.id) return [];
      const data = await fetchSubscriptionInvoices(
        subscription?.id,
        businessId,
      );
      return data;
    },
    enabled,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    isFetching: query.isFetching,
    isRefetching: query.isRefetching,
    refetch: query.refetch,
  };
}

export default useGetSubscriptionInvoices;
